import { createFileRoute } from "@tanstack/react-router";
import { fleaMarketItemDetailQueryOptions } from "~/features/fleamarket/api";
import { FleaMarketItemDetailTemplate } from "~/features/fleamarket/FleaMarketItemDetailTemplate";

export const Route = createFileRoute("/_authenticated/fleamarket/item/$itemId")(
  {
    loader: ({ context: { queryClient }, params: { itemId } }) =>
      queryClient
        .ensureQueryData(fleaMarketItemDetailQueryOptions(itemId))
        .catch(() => undefined),
    component: FleaMarketItemDetailTemplate,
  },
);
